module.exports = "images/favicon-96x96.e95533a00a44cf88ff44f21ce4980d23.png";